import Loading from './Loading'
import LoadingDots from './LoadingDots';
import LoadingWrapper from './LoadingWrapper';

export { Loading, LoadingDots, LoadingWrapper };
export default Loading;